import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaLinkedin, FaXTwitter } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import footerTymeplusLogo from "../../../Assests/ForesytsDark.svg";
import { FooterWrap } from "./style";
import footerlogo from "../../../../src/Assests/trackright/footerlogo.svg";

export const Footers = () => {
  const navigate = useNavigate();

  const handleLinkedInClick = () => {
    window.open("https://www.linkedin.com/company/waila-technology/", "_blank");
  };

  const handleTwitterClick = () => {
    window.open("https://x.com/wailatech", "_blank");
  };

  const openEmail = (id) => {
    window.open(`mailto:${id}`);
  };

  return (
    <FooterWrap>
      <section
        id="Footer contain-margin"
        style={{ backgroundColor: "#1f243b" }}
      >
        <footer class="footer">
          <div class="container">
            <div class="row footer-row">
              <div class="col footer-left">
                <h4>Find Us</h4>
                <p>info@trackright.africa</p>
                <p>+254 734 558 808</p>
                <p>+254 733 832 277</p>
                <p>P.O Box 1230–20100 Nakuru</p>
              </div>

              <div class="col footer-center">
                <img src={footerlogo} alt="TrackRight" class="footer-logo" />
                <p class="footer-link">Contact</p>
                <p class="footer-link">Feedback</p>
                <p class="copyright">©2026 TrackRight. All rights reserved</p>
              </div>

              <div class="col footer-right">
                <h4>Follow Us</h4>
                <div class="social-icons">
                  <span
                    onClick={() =>
                      window.open(
                        "https://www.linkedin.com/company/trackright-africa/",
                        "_blank",
                      )
                    }
                    class="icon"
                  >
                    in
                  </span>
                  <span
                    onClick={() =>
                      window.open(
                        "https://www.linkedin.com/company/trackright-africa/",
                        "_blank",
                      )
                    }
                    class="icon"
                  >
                    f
                  </span>
                </div>
                <p
                  onClick={() => {
                    navigate("/PrivacyPoliicee");
                  }}
                  class="footer-policy"
                >
                  Privacy policy | Terms & Conditions
                </p>
              </div>
            </div>
          </div>
        </footer>
      </section>
    </FooterWrap>
  );
};
